/* eslint-disable */
import noUiSlider from 'nouislider'
import 'nouislider/dist/nouislider.css'

window.noUiSlider = noUiSlider
const $ = window.$
import CircleProgress from 'js-circle-progress'

window.circleProgress = function() {
  return new CircleProgress(...arguments)
}

/*----------------------------------------------------------
 Detect Mobile Browser
 -----------------------------------------------------------*/
 if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  $('html').addClass('ismobile')
}

$(document).ready(() => {
  $('body').on('click', '[data-ma-action]', function(e) {
    e.preventDefault()

    const $this = $(this)
    const action = $(this).data('ma-action')

    switch (action) {
      /*-------------------------------------------
             Sidebar & Chat Open/Close
             ---------------------------------------------*/

      /*-------------------------------------------
             Mainmenu Submenu Toggle
             ---------------------------------------------*/


      /*-------------------------------------------
             Header Notification Clear
             ---------------------------------------------*/
      case 'clear-notification':
        var x = $this.closest('.list-group')
        var y = x.find('.list-group-item')
        var z = y.length

        $this.parent().fadeOut()

        x.find('.list-group').prepend('<i class="grid-loading hide-it"></i>')
        x.find('.grid-loading').fadeIn(1500)

        var w = 0
        y.each(function() {
          const z = $(this)
          setTimeout(() => {
            z.addClass('animated fadeOutRightBig')
              .delay(1000)
              .queue(() => {
                z.remove()
              })
          }, (w += 150))
        })

        $.ajax({
          url: '/notificationfeed/clear',
          type: 'POST',
          success: function(data) {
            $('.wds-navigation-account-menu-icon .wds-badge-wrapper')
                .remove();
          },
        })

        // Popup empty message
        if (y.length > 0) {
          setTimeout(() => {
            x.find('.lg-body')
              .addClass('text-center p-20')
              .text('No new notifications')
            $('.him-notification').addClass('empty')
          }, z * 150 + 200)
        }
        break
    }
  })

  /*----------------------------------------------------------
     Dropdown Menu
     -----------------------------------------------------------*/
  if ($('.dropdown')[0]) {
    // Propagate
    $('body').on('click', '.dropdown.open .dropdown-menu', (e) => {
      e.stopPropagation()
    })

    $('.dropdown').on('shown.bs.dropdown', function(e) {
      if ($(this).attr('data-animation')) {
        var $animArray = []
        var $animation = $(this).data('animation')
        $animArray = $animation.split(',')
        var $animationIn = `animated ${$animArray[0]}`
        var $animationOut = `animated ${$animArray[1]}`
        var $animationDuration = ''
        if (!$animArray[2]) {
          $animationDuration = 500 // if duration is not defined, default is set to 500ms
        } else {
          $animationDuration = $animArray[2]
        }

        $(this)
          .find('.dropdown-menu')
          .removeClass($animationOut)
        $(this)
          .find('.dropdown-menu')
          .addClass($animationIn)
      }
    })

    $('.dropdown').on('hide.bs.dropdown', function(e) {
      if ($(this).attr('data-animation')) {
        e.preventDefault()
        var $this = $(this)
        var $dropdownMenu = $this.find('.dropdown-menu')

        $dropdownMenu.addClass($animationOut)
        setTimeout(() => {
          $this.removeClass('open')
        }, $animationDuration)
      }
    })
  }

  /*-----------------------------------------------------------
     Waves
     -----------------------------------------------------------*/
  ;(function() {
    window.Waves.attach('.btn:not(.btn-icon):not(.btn-float):not(input)')
    window.Waves.attach('.btn-icon, .btn-float', ['waves-circle', 'waves-float'])
    window.Waves.init()
  })()

  /*----------------------------------------------------------
     Bootstrap Accordion Fix
     -----------------------------------------------------------*/
  if ($('.collapse')[0]) {
    // Add active class for opened items
    $('.collapse').on('show.bs.collapse', function(e) {
      $(this)
        .closest('.panel')
        .find('.panel-heading')
        .addClass('active')
    })

    $('.collapse').on('hide.bs.collapse', function(e) {
      $(this)
        .closest('.panel')
        .find('.panel-heading')
        .removeClass('active')
    })

    // Add active class for pre opened items
    $('.collapse.in').each(function() {
      $(this)
        .closest('.panel')
        .find('.panel-heading')
        .addClass('active')
    })
  }
})
